import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ValidationMessageComponent } from '../../../../shared/components/validation-message/validation-message.component';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { ApiService } from '../../../../core/services/api.service';
import { SrStatus } from '../../../../shared/constants/status.enum';
import { Utils } from '../../../../Utils/utils';
import { FieldValue, ServiceName, SrIOName, UserType } from '../../../../shared/constants/services.enum';
import { SharedService } from '../../../../shared/services/shared.service';
import { CommonSrRequest, HierarchyWrapper } from '../../../../shared/models/services-request/common.model';
import { AttestationServiceModel } from '../../../../shared/models/services-request/attestation-service.model';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { CooQueryRequest } from '../certificate-of-origin/models/coo-query-request.model';
import { HAPPINESS_SERVICES } from './models/happiness-services.model';
import { environment } from '../../../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LinkMemberQueryRequestModel } from '../add-business/models/link-member-query-request.model';
import { CurrencyPipe } from '../../../../shared/pipes/currency.pipe';
import { NotesComponent } from "../../../../shared/components/notes/notes.component";
import { CompanyInfoNoticeComponent } from "../../../../shared/components/company-info-notice/company-info-notice.component";
import { DcMethodValues } from '../../../../shared/constants/dc-method.constants';

@Component({
  selector: 'app-success-page',
  imports: [CommonModule, TranslateModule, ButtonComponent, ValidationMessageComponent, RouterLink, SkeletonLoaderComponent, CurrencyPipe, NotesComponent, CompanyInfoNoticeComponent],
  templateUrl: './success-page.component.html',
  styleUrl: './success-page.component.scss'
})
export class SuccessPageComponent {

  attestationRequest = new CommonSrRequest<AttestationServiceModel, HierarchyWrapper<AttestationServiceModel>>();
  serviceName = ServiceName;
  fieldValue = FieldValue;
  happinessUrl!: SafeResourceUrl;
  totalSteps: number = 0;
  ataAmendmentAmount: any = 100;
  step: number = 0
  srStatus = SrStatus;
  srNumber: any = "";
  srDetails: any = "";
  showHappinessMeter: boolean = true;

  suggestedServices: any = [{
    id: "coo",
    serviceName: "SUCCESS_PAGE.CERTIFICATE_OF_ORIGIN",
    path: `${RoutesPath.SERVICE}/${RoutesPath.COO.ISSUE}`

  }, {
    id: "ata",
    serviceName: "SUCCESS_PAGE.ATA_CARNET",
    path: `${RoutesPath.SERVICE}/${RoutesPath.ATA.CARNET}`
  }];
  userLoginName: string = "";
  userCSN: string = "";
  companyName: string = "";
  loader: boolean = true;
  lang: string = "en";
  loginUserEmail: string;
  feesAmount: any = "";
  isCompanyInformationCompleted: boolean = false;
  companyInfoLoading = false;
  // This method is used to initialize the class instance using route, router, api, shared service, and sanitizer
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private sharedService: SharedService,
    private sanitizer: DomSanitizer
  ) {
    this.lang = this.sharedService.getCurrentLang() || 'en';
    this.userLoginName = this.sharedService.getUserProfile()['Login Name'];
    this.loginUserEmail = this.sharedService.getUserProfile()['EMail Addr'];
    this.companyName = this.sharedService.getPrimaryAccount()['DC Name English'];
    this.userCSN = this.sharedService.getCsnAccountId('csn');

    // SR Number in the url
    this.route.params.subscribe(params => {
      this.srNumber = params['sr_no'];
      if (this.srNumber) {
        this.getSRDetail();
        this.checkCompanyInformationStatus();
      } else {
        this.router.navigate([RoutesPath.DASHBOARD]);
        return;
      }
    });
  }
  productType: string = "";
  // This method is used to get sr detail
  getSRDetail() {
    let srDetail = this.sharedService.getSrResponse();
    this.feesAmount = srDetail.feesAmount ? srDetail.feesAmount : '';
    this.totalSteps = srDetail.totalSteps ? srDetail.totalSteps : 3;
    this.step = srDetail.step ? srDetail.step : 2;
    // Open happiness meter only for non Issue new COO services as per requirement
    if (srDetail.service != ServiceName.ISSUE_NEW_COO) {
      this.openHappinessMeter();
    }
    if (srDetail.IOName == SrIOName.ATTESTATION) {
      this.getSRDetail_attestation(srDetail.service);
      return;
    }
    if (srDetail.IOName == SrIOName.ISSUE_NEW_ATA_CARNET) {
      this.getSRDetail_AtaCarnet(srDetail.service);
      return;
    }
    if (srDetail.IOName == SrIOName.COO_CREATE) {
      this.suggestedServices = this.suggestedServices.filter((s: any) => s.id != 'coo');
      this.suggestedServices.push({
        id: "attestation",
        serviceName: "SR_VERIFY_SIGNATURE",
        path: `${RoutesPath.SERVICE}/${RoutesPath.ATTESTATION.VERIFY_SIGNATURE}`

      })
      this.getSRDetail_COO(srDetail.service);
      return;
    }
    if (srDetail.IOName == SrIOName.LINK_MEMBER) {
      this.getSRDetail_LinkMember(srDetail.service);
      return;
    }
    if (srDetail.IOName == "") {
      this.getMrmAwardDetail();
      return;
    }
    const requestPayload = {
      "body": {
        "ProcessName": "DC Get SR Details Web WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.SUCCESS_PAGE,
        "SR Number": this.srNumber,
        "IOName": srDetail && srDetail.IOName ? srDetail.IOName : SrIOName.MEMBERSHIP
      }
    };
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_SR_DETAIL,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        this.loader = false;
        if (response['Error Code'] == null || response['Error Code'] == "" && response?.SiebelMessage["DC Mem SR"]) {
          this.srDetails = response?.SiebelMessage["DC Mem SR"];
          if (this.srDetails["SR Sub Type"] == ServiceName.INFORMATION_SERVICES) {
            let fsCharge: any = this.srDetails["FS Charge Web"] ? Utils.checkIsArray(Utils.checkIsArray(this.srDetails["FS Charge Web"])) : "";
            let filtered = fsCharge.filter(
              (item: any) => item["Product Name"] !== "VAT 5%"
            )
            if (filtered && filtered.length > 0) {
              this.productType = filtered[0]["DC Product Type Portal"]
            }
          }
        }
      }
    })
  }

  // This method is used to get sr detail attestation using sub service
  getSRDetail_attestation(subService: string) {
    let srDetail = this.sharedService.getSrResponse();
    this.attestationRequest.body.ProcessName = "DC Community Portal SR Process Wrapper WF";
    this.attestationRequest.body.DCMethod = "QUERY"; //SUBMIT 
    this.attestationRequest.body.DCLoginName = this.userLoginName;
    this.attestationRequest.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';

    let ServiceRequest: any = {
      "CSN": srDetail?.memberCSN ? srDetail.memberCSN : this.userCSN,
      "SR Type": ServiceName.SIGNATURE_OF_VERIFICATION,
      "SR Sub Type": this.lang == 'ar' ? srDetail.serviceSubTypeAr : (srDetail.serviceSubTypeEn), // subService,
      "SR Number": this.srNumber
    }

    this.attestationRequest.body.DCIncomingHierarchy = {
      MessageId: Utils.generateUniqueId(),
      IntObjectName: "DCCreateSVSIO",
      MessageType: "Integration Object",
      IntObjectFormat: "Siebel Hierarchical",
      ListOfDCCreateSVSIO: {
        "Service Request": ServiceRequest
      }
    }

    this.api.post(
      ApiRoot.ATTESTATION_DCCICREATESVS,
      ApiEndPoints.ATTESTATION_GET_SR_DETAIL,
      this.attestationRequest
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        this.loader = false;
        if (response['Error Code'] == null || response['Error Code'] == "" && response?.SiebelMessage['Service Request']) {
          this.srDetails = response?.SiebelMessage["Service Request"];
        }
      }
    })
  }

  // This method is used to get sr detail ata carnet using sub service
  getSRDetail_AtaCarnet(subService: string) {
    let srDetail = this.sharedService.getSrResponse();
    let requestPayload: any = {
      "body": {
        "ProcessName": "DC Community Portal SR Process Wrapper WF",
        "DCMethod": "QUERY",
        "DCLoginName": this.userLoginName,
        "DCLanguage": this.lang == 'ar' ? 'ARA' : 'ENU',
        "DCIncomingHierarchy": {
          "MessageId": Utils.generateUniqueId(),
          "IntObjectName": "DC Community Portal SR IO",
          "MessageType": "Integration Object",
          "IntObjectFormat": "Siebel Hierarchical",
          "ListOfDC Community Portal SR IO": {
            "DC Community Portal SR": {
              "SR Number": this.srNumber,
              "SR Type": (srDetail.serviceSubTypeEn == ServiceName.MYSTERY_SHOPPER_MEMBERSHIP || srDetail.serviceSubTypeAr == ServiceName.MYSTERY_SHOPPER_MEMBERSHIP) ? ServiceName.SERVICE_EXCELLENCE_PROGRAMME : ServiceName.ATA_CARNET,
              "Sub Type": this.lang == 'ar' ? srDetail.serviceSubTypeAr : (srDetail.serviceSubTypeEn),
              "CSN": srDetail?.memberCSN ? srDetail.memberCSN : this.userCSN
            }
          }
        }
      }
    }
    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_QUERY_SERVICEREQUEST,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        this.loader = false;
        if (response['Error Code'] == null || response['Error Code'] == "" && response?.SiebelMessage['DC Community Portal SR']) {
          this.srDetails = response?.SiebelMessage["DC Community Portal SR"];
          if (this.srDetails["Sub Type"] == ServiceName.AMENDMENT_CARNET && this.sharedService.getPrimaryAccount()?.['Account Type Code'] != UserType.MEMBER) {
            this.ataAmendmentAmount = 200;
          }
        }
      }
    })
  }

  // This method is used to get sr detail coo using sub service
  getSRDetail_COO(subService: string) {
    let srDetail = this.sharedService.getSrResponse();
    const queryReq = new CooQueryRequest();

    queryReq.body.DCLoginName = this.userLoginName;
    queryReq.body.DCMethod = "QUERY"

    queryReq.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    let portalSr = queryReq.body.DCIncomingHierarchy.ListOfDCCOOMOBILE.MEMBER;

    portalSr.CSN = srDetail?.memberCSN ? srDetail.memberCSN : this.userCSN;
    portalSr.ListOfSERVICEREQ.SERVICEREQ["SR Number"] = this.srNumber;
    portalSr.ListOfSERVICEREQ.SERVICEREQ.CSN = this.userCSN;
    portalSr.ListOfSERVICEREQ.SERVICEREQ['SR Type'] = ServiceName.COO;
    portalSr.ListOfSERVICEREQ.SERVICEREQ['SR Sub Type'] = this.lang == 'ar' ? srDetail.serviceSubTypeAr : (srDetail.serviceSubTypeEn); //subService

    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.QUERY_COO,
      queryReq
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        this.loader = false;
        if (response["Error Code"] == null || response["Error Code"] == "" && response["Error Message"] == null || response["Error Message"] == "" && response["SiebelMessage"]?.["DC Service Request Thin"]) {
          this.srDetails = response?.SiebelMessage["DC Service Request Thin"];
          this.srDetails["SR Number"] = response.DCSRNumber;
          this.srDetails['DCTotalFees'] = response.DCTotalFees;
        }
      }
    })
  }

  // This method is used to get sr detail link member using sub service
  getSRDetail_LinkMember(subService: string) {
    let srDetail = this.sharedService.getSrResponse();
    const queryReq = new LinkMemberQueryRequestModel();

    queryReq.body.DCLoginName = this.userLoginName;
    queryReq.body.DCMethod = "QUERY"

    queryReq.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();
    let portalSr = queryReq.body.DCIncomingHierarchy['ListOfDC Community Portal SR IO']['DC Community Portal SR'];

    portalSr.CSN = this.userCSN;
    portalSr["SR Number"] = this.srNumber;
    portalSr['SR Type'] = ServiceName.USER_MANAGEMENT;
    portalSr['Sub Type'] = this.lang == 'ar' ? srDetail.serviceSubTypeAr : (srDetail.serviceSubTypeEn) //subService;

    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_QUERY_SERVICEREQUEST,
      queryReq
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        this.loader = false;
        if (response["Error Code"] == null) {
          // this.srDetails = response; //?.SiebelMessage["DC Community Portal SR"];
          this.srDetails = response?.SiebelMessage["DC Community Portal SR"];
          // this.srDetails["SR Number"] = response.DCSRNumber;
          // this.srDetails["SR Sub Type"] = this.srDetails["DCSRSubType"];
          // this.srDetails["Status"] = SrStatus.Closed;;
        }
      }
    })
  }

  // this method is used to get sr detail for MRM award
  getMrmAwardDetail() {
    const requestPayload = {
      "body": {
        "ProcessName": "DC Create Update MRM SR WF",
        "DC Method": "QUERY",
        "SR Number": this.srNumber,
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
      }
    };
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.RUN_PROCESS,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response['Error Code'] == null || response['Error Code'] == "") {
          this.srDetails = response;
          this.srDetails["Sub Type"] = this.srDetails["SR Sub Type"];
        }
      }
    })
  }

  // This method is used to calculate form progress
  get formProgress() {
    return 100;
    // if (this.srDetails["Status"] == SrStatus.Approved) {
    //   return 100;
    // } else {
    //   return Utils.calculateFormProgress(this.step, this.totalSteps);
    // }
  }

  // This method is used to goto dashboard
  gotoDashboard() {
    let srDetail = this.sharedService.getSrResponse();
    if (srDetail.service == ServiceName.ISSUE_NEW_COO && environment.enableHappinessMeter) {
      this.openHappinessMeter();
    } else {
      this.router.navigate([RoutesPath.DASHBOARD]);
    }
  }
  // This method is used to create copy
  createCopy(type: any) {
    if (type == "star-new") {
      this.router.navigate(
        [`${RoutesPath.SERVICE}/${RoutesPath.COO.ISSUE}`]
      );
    } else {
      this.router.navigate(
        [`${RoutesPath.SERVICE}/${RoutesPath.COO.ISSUE}`],
        { queryParams: { csr: this.srDetails["SR Number"] } }
      );
    }
  }

  // This method is used to open happiness meter
  openHappinessMeter() {
    if (!environment.enableHappinessMeter) {
      this.showHappinessMeter = false;
      return;
    }
    let Url = this.createServiceHappinessUrl();
    if (Url) {
      setTimeout(() => {
        this.happinessUrl = this.sanitizer.bypassSecurityTrustResourceUrl(Url);
        this.showHappinessMeter = true;
      }, 3000)
    }
  }

  // This method is used to create service happiness url
  createServiceHappinessUrl(): string | null {
    let srDetail = this.sharedService.getSrResponse();
    let serviceName = srDetail.service;       // e.g. "Renew"
    let serviceRequestNo = this.srNumber      // from your SR details
    let language = this.lang; // default to English

    // Find matching service
    const service = HAPPINESS_SERVICES.find(s => s.value === serviceName);

    if (!service) {
      console.warn("Happiness service not found:", serviceName);
      return null;
    }
    // Build URL
    const url = new URL(`${environment.servicesHappinessURL}/HappinessProccessor`);

    url.searchParams.set("type", "!T");
    url.searchParams.set("sc", service.serviceCode.toString());
    url.searchParams.set("sd", service.description);
    url.searchParams.set("channel", "WEB");
    url.searchParams.set("ano", "WEB_APP");
    url.searchParams.set("sno", serviceRequestNo);
    url.searchParams.set("ln", language);
    url.searchParams.set("platform", "windows");

    return url.toString();
  }
  showNotes: boolean = false;
  closeNotes(e: any) {
    this.showNotes = false;
  }

  private checkCompanyInformationStatus(): void {
    const accountType = this.sharedService.getPrimaryAccount()?.['Account Type Code'];
    if (accountType === UserType.NON_MEMBER || accountType === UserType.NON_MEMBER_AR) {
      this.isCompanyInformationCompleted = true;
      return;
    }
    const accountId = this.sharedService.getCsnAccountId('id');
    if (!accountId) {
      this.isCompanyInformationCompleted = true;
      return;
    }
    this.companyInfoLoading = true;
    this.sharedService.checkCompanyInformationRequiredFields(accountId).subscribe({
      next: (isComplete: boolean) => {
        this.isCompanyInformationCompleted = isComplete;
        this.companyInfoLoading = false;
      },
      error: () => {
        this.isCompanyInformationCompleted = false;
        this.companyInfoLoading = false;
      },
    });
  }
  gotoCompanyInfo() {
    let path = `${RoutesPath.SERVICE}/${RoutesPath.COMPANY_INFORMATION}`;
    this.router.navigate([path]);
  }
  getSRTypeValue(srType: string, srSubType?: string): string {
   return Utils.getSrTypeValue(srType, srSubType);
  }

}
